import React from 'react';
import { connect } from 'react-redux';
import AddOrJoinButtonBar from '../project/addAndJoin/AddOrJoinButtonBar';

const FolderManagerHeader = () => {
    return (
        <AddOrJoinButtonBar />
    )
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
    }
}

export default connect(mapStateToProps)(FolderManagerHeader);
